import { render } from "./FileDeleteForm.vue?vue&type=template&id=ed9d0c40"
import script from "./FileDeleteForm.vue?vue&type=script&lang=js"
export * from "./FileDeleteForm.vue?vue&type=script&lang=js"
script.render = render

export default script